<template>
  <div :class="bem()">
    <div
      v-if="category.name"
      :class="bem('header')"
    >
      <NuxtLink
        :to="resolveLocalePath(category.link)"
      >
        <VisionHeading
          tag="h3"
          size="h3"
        >
          {{ category.name }}
        </VisionHeading>
      </NuxtLink>
    </div>
    
    <ul :class="bem('articles')">
      <li
        v-for="article in category.articles.slice(0, limit)"
        :key="article.id"
        :class="bem('article')"
      >
        <NuxtLink
          :to="resolveLocalePath(article.link)"
        >
          <div :class="bem('article-title')">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="parseText(article.title)" />

            <VisionIcon
              :class="bem('icon')"
              icon="chevron"
              size="x-small"
              colour="black"
            />
          </div>
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { parseText } from '~/assets/js/helpers/text.js'

const { resolveLocalePath } = useUrlBuilder()
const bem = useBEM('SupportArticleList')

defineProps({
  category: { type: Object, required: true},
  limit: { type: Number, default: 25 }
})
</script>

<style lang="postcss">
.SupportArticleList {
  @apply grow overflow-hidden
    border border-solid border-grey-400
    shadow-sm
    rounded-md
    no-underline
    flex-col
    p-xs sm:p-sm;

  &__header {
    @apply pt-2 pb-6 border-b border-solid border-grey-400
      mb-4;
  }

  &__articles {
    @apply flex flex-col;
  }

  &__article {
    @apply transition ease-linear rounded overflow-hidden p-2
      -mx-2;

    &:hover {
      @apply bg-gray-50;

      .SupportArticleList__icon {
        @apply scale-90 opacity-80;
      }
    }
  }

  &__icon {
    @apply transition ease-linear transform scale-75 opacity-50;
  }

  &__article-title {
    @apply text-sm sm:text-base w-full flex justify-between items-center;
  }
}
</style>